// Per-user preferences for which optional metrics the dashboard cards display.
// Persisted in localStorage so the choice survives reloads. The three gauges
// (temperature, humidity, CO2), the silo bars, age and weight are always shown;
// only the secondary and derived metrics below are toggleable.

const STORAGE_KEY = 'cardMetricsPreferences'

// Default visibility. Existing behaviour is preserved (pressure and water on);
// the derived comfort metrics are opt-in to keep the cards uncluttered.
const DEFAULT_PREFERENCES = {
  pressure: true,
  water: true,
  feelsLike: false,
  thi: false,
  enthalpy: false,
  ventilation: false
}

function sanitize (raw) {
  const result = Object.assign({}, DEFAULT_PREFERENCES)
  if (raw && typeof raw === 'object') {
    Object.keys(DEFAULT_PREFERENCES).forEach(key => {
      if (typeof raw[key] === 'boolean') {
        result[key] = raw[key]
      }
    })
  }
  return result
}

function getStoredPreferences () {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    return sanitize(stored ? JSON.parse(stored) : null)
  } catch (err) {
    return Object.assign({}, DEFAULT_PREFERENCES)
  }
}

function persist (preferences) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences))
  } catch (err) {
    // ignore storage errors (e.g. private mode / quota)
  }
}

export default {
  state: {
    cardMetricsPreferences: getStoredPreferences()
  },
  getters: {
    cardMetricsPreferences (state) {
      return state.cardMetricsPreferences
    }
  },
  mutations: {
    setCardMetricsPreferences (state, preferences) {
      state.cardMetricsPreferences = preferences
    }
  },
  actions: {
    setCardMetricPreference ({ commit, state }, { key, value }) {
      if (!(key in DEFAULT_PREFERENCES)) {
        return
      }
      const preferences = Object.assign({}, state.cardMetricsPreferences, {
        [key]: !!value
      })
      persist(preferences)
      commit('setCardMetricsPreferences', preferences)
    },
    resetCardMetricPreferences ({ commit }) {
      const preferences = Object.assign({}, DEFAULT_PREFERENCES)
      persist(preferences)
      commit('setCardMetricsPreferences', preferences)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/cardMetrics/index.js